<template>
  <section id="recommended-supplies" class="landscape-products-wrap" v-if="hasAnyProduct">
    <div class="products-header">
      <h5 class="section-title">Recommended Supplies</h5>
    </div>

    <div class="landscape-products" ref="productsPlaceholder">
      <supply-card
        v-for="(product, index) in products" :key="index"
        :product="product" :isAdmin="isAdmin"
        :daily-purchase-limit-amount="dailyPurchaseLimitAmount"
        :hot-products-disclaimer="hotProductsDisclaimer"
        :payment_methods="payment_methods"
        class="margin-10" />
    </div>
  </section>
</template>

<script>
import SupplyCard from "./../../SupplyCard.vue"
import { relatedProducts as config } from "../../../config/products"

export default {
  name: "RecommendedSupplies",
  components: { SupplyCard },
  props: ["products", "isAdmin", "dailyPurchaseLimitAmount", "hotProductsDisclaimer", "payment_methods"],
  computed: {
    hasAnyProduct() {
      return this.products.length !== 0
    }
  },
  mounted() {
    $(this.$refs.productsPlaceholder).slick(config.slickOptions)
  }
}
</script>

<style lang="scss">
#recommended-supplies {
  .margin-10 {
    margin: 0 10px;
  }

  .arrow-prev {
    right: 69px;
  }

  .arrow-next {
    right: -3px;
  }
}
</style>
